import Axios from "axios";

export const SelectFactureFrs = (a, b, c, d, e) => {
  return (dispatch) => {
    Axios.get(
      `https://www.24-crm.tn/webservice/api/FacFrs?typpe=FF&coddos=${a}&serveur=${b}&user=${c}&pwd=${d}&database=${e}`
    ).then((response) => {
      return dispatch({ type: "FACTURE_FRS_SELECT", payload: response.data });
    });
  };
};
